import React from "react";
import { useRequestContext } from "../../hooks/useRequest";
import { ClientVerifyProduct } from "../../../order/components/SellItem/ClientVerifyProduct";
import { Collapsible } from "../../../components";
import { SectionTrigger } from "../../../orderManagement/molecules/SectionTrigger";
import { pxSellSectionId } from "../../v2/sectionConfig";

export function VerifySerial({ step, idx, navigateTo }) {
  const { getContext, onVerificationDone, toggleStep } = useRequestContext();

  // Pass the step so getContext honours step.pxSellIdx: on a PX order these
  // sections exist once PER SELL REQUEST, and without it every instance would
  // resolve the primary (order) request instead of its own trade-in.
  const { request } = getContext(idx, step);

  // After a successful verify, advance the V2 nav to the next sell-flow
  // section. onVerificationDone is the V1 journey hook; we keep calling it
  // for back-compat (refresh + V1 journey mutation) and chain navigateTo for
  // the V2 page. A PX slot has no consignment agreement — the trade-in is a
  // purchase — so it goes straight to ITS purchasing agreement; a standalone
  // sell request still goes to the consignment one.
  const pxSellIdx = step?.pxSellIdx;
  const nextSectionId =
    pxSellIdx === null || pxSellIdx === undefined
      ? "consignment_agreement"
      : pxSellSectionId("purchasing_agreement", pxSellIdx);

  const handleDone = (data) => {
    onVerificationDone(data);
    navigateTo?.(nextSectionId);
  };

  return (
    <Collapsible
      trigger={<SectionTrigger label={step.label} icon="serial" />}
      open={step.open}
      handleTriggerClick={() => toggleStep(idx)}
      testId="confirm-request"
    >
      <div className="mt-4">
        <ClientVerifyProduct request={request} onDone={handleDone} />
      </div>
    </Collapsible>
  );
}
